import { useCallback, useLayoutEffect, useRef } from 'react';

/**
 * Returns a stable callback that always invokes the latest implementation.
 *
 * Use this for work launched by an effect whose lifecycle is controlled by
 * explicit trigger values. The stable identity prevents unrelated render-time
 * callback recreation from becoming an effect trigger, while the ref prevents
 * stale closures when the effect eventually invokes the work.
 */
const useEventCallback = (callback) => {
  const callbackRef = useRef(callback);

  useLayoutEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  return useCallback((...args) => callbackRef.current(...args), []);
};

export default useEventCallback;
